export const classes = {
  wrapper: 'w-[350px]',
  card: 'shadow-dialog w-full flex flex-col py-1',
  icon: 'text-green-3',
  spinner: 'flex',
  file: 'place-start py-4',
  name: 'ml-2 text-grey-8 dark:text-mauve-1 text-base',
};
